<template>
  <DeviceAlarm
    :isOpen="isShowAlarmModal"
    @close="deviceAlarmToggle"
    :id="device_code"
    :title="$t('alarmsList')"
  />
  <loading :loading="loadingData" />
  <sidebar
    :backOn="true"
    :noSocial="true"
    :isAlarm="devicesStore.deviceData.is_alarm_device"
    @alarmList="deviceAlarmToggle"
  />
  <div class="device-container">
    <deviceCard :id="props.id" />
  </div>
  <div class="dashboard-container">
    <IdroTitle :title="title" />
    <div class="content">
      <div class="md-icon-card">
        <router-link :to="{ name: 'SensorView' }"
          ><img src="@/assets/sensor.png"
        /></router-link>
        <p>{{ $t("sensor") }}</p>
      </div>
      <div class="md-icon-card">
        <router-link :to="{ name: 'IrrigationView' }"
          ><img src="@/assets/irrigation.png"
        /></router-link>
        <p>{{ $t("irrigation") }}</p>
      </div>
      <div class="md-icon-card">
        <router-link :to="{ name: 'FerrigationView' }"
          ><img src="@/assets/ferrigation.png"
        /></router-link>
        <p>{{ $t("fertigation") }}</p>
      </div>
      <div class="md-icon-card" v-if="devicesStore.deviceData.role !== 'user'">
        <router-link :to="{ name: 'Webcam' }">
          <img src="@/assets/webcam.png" />
        </router-link>
        <p>{{ $t("webcam") }}</p>
      </div>
      <div class="md-icon-card opacity-40" v-else>
        <img src="@/assets/webcam.png" />
        <p>{{ $t("webcam") }}</p>
      </div>
      <div class="md-icon-card" v-if="devicesStore.deviceData.role !== 'user'">
        <router-link :to="{ name: 'MapView' }">
          <img src="@/assets/map.png" />
        </router-link>
        <p>{{ $t("map") }}</p>
      </div>
      <div class="md-icon-card opacity-40" v-else>
        <img src="@/assets/map.png" />
        <p>{{ $t("map") }}</p>
      </div>
      <div class="md-icon-card">
        <router-link :to="{ name: 'ReportView' }"
          ><img src="@/assets/report.png"
        /></router-link>
        <p>{{ $t("report") }}</p>
      </div>
      <div class="weather-data">
        <p class="my-3 lg:text-2xl md:text-xl sm:text-lg text-lg font-bold">
          {{ $t("curentWeather") }}
        </p>
        <div class="px-2">
          <div
            class="flex w-full justify-between px-3 lg:px-12 md:px-12 mb-3 lg:mb-2"
          >
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm font-bold">
              Temperature
            </p>
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm text-slate-900">
              {{ tempC }} °C
            </p>
          </div>
        </div>
        <div
          class="px-2 transition-all ease-in-out duration-300 overflow-hidden"
          :style="{
            maxHeight: showData ? '1000px' : '0',
            opacity: showData ? '1' : '0',
          }"
        >
          <div
            class="flex w-full justify-between px-3 lg:px-12 md:px-12 mb-2 lg:mb-2"
          >
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm font-bold">
              Wind Speed
            </p>
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm text-slate-900">
              {{ windKph }} kph
            </p>
          </div>
          <div
            class="flex w-full justify-between px-3 lg:px-12 md:px-12 mb-2 lg:mb-2"
          >
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm font-bold">
              Wind Direction
            </p>
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm text-slate-900">
              {{ windDir }}
            </p>
          </div>
          <div
            class="flex w-full justify-between px-3 lg:px-12 md:px-12 mb-2 lg:mb-2"
          >
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm font-bold">
              Pressure
            </p>
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm text-slate-900">
              {{ pressureMb }} mb
            </p>
          </div>
          <div
            class="flex w-full justify-between px-3 lg:px-12 md:px-12 mb-2 lg:mb-2"
          >
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm font-bold">
              Precipitation
            </p>
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm text-slate-900">
              {{ precipMm }} mm
            </p>
          </div>
          <div
            class="flex w-full justify-between px-3 lg:px-12 md:px-12 mb-2 lg:mb-2"
          >
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm font-bold">
              Humidity
            </p>
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm text-slate-900">
              {{ humidity }}%
            </p>
          </div>
          <div
            class="flex w-full justify-between px-3 lg:px-12 md:px-12 mb-2 lg:mb-2"
          >
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm font-bold">
              Max Temp C
            </p>
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm text-slate-900">
              {{ maxTempC }} °C
            </p>
          </div>
          <div
            class="flex w-full justify-between px-3 lg:px-12 md:px-12 mb-2 lg:mb-2"
          >
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm font-bold">
              Min Temp C
            </p>
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm text-slate-900">
              {{ minTempC }} °C
            </p>
          </div>
          <div
            class="flex w-full justify-between px-3 lg:px-12 md:px-12 mb-2 lg:mb-2"
          >
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm font-bold">
              Avg Temp C
            </p>
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm text-slate-900">
              {{ avgTempC }} °C
            </p>
          </div>
          <div
            class="flex w-full justify-between px-3 lg:px-12 md:px-12 mb-2 lg:mb-2"
          >
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm font-bold">
              Avg Humidity
            </p>
            <p class="lg:text-lg md:text-lg sm:text-sm text-sm text-slate-900">
              {{ avgHumidity }}%
            </p>
          </div>
        </div>
        <div
          class="mt-5 group py-2 bg-sky-200 hover:bg-sky-300 rounded-b-[20px] md:rounded-b-[30px] lg:rounded-b-[40px] cursor-pointer"
          @click="showDataWeather()"
        >
          <p class="text-sm text-sky-500 group-hover:text-sky-700">
            {{ showData ? "Hide" : "Show More" }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDevicesStore } from "@/stores/DevicesStore";
import { storeToRefs } from "pinia";
import {
  defineAsyncComponent,
  computed,
  onBeforeMount,
  onUnmounted,
  ref,
} from "@vue/runtime-core";
import { useAlarmStore } from "@/stores/alarm/AlarmStore";
import { useDataStore } from "@/stores/DataStore";
import { useWeatherStore } from "@/stores/WeatherStore";
const loadingData = ref(false);

//props
const props = defineProps({
  id: String,
});

//asynchronus component
const deviceCard = defineAsyncComponent(() =>
  import("@/components/cards/deviceCardSmall.vue")
);

const DeviceAlarm = defineAsyncComponent(() =>
  import("@/components/modal/devices/DeviceAlarm.vue")
);
//state
const devicesStore = useDevicesStore();
const weatherStore = useWeatherStore();
const alarmStore = useAlarmStore();
const dataStore = useDataStore();
const { isLoading } = storeToRefs(useDevicesStore());
const tempC = ref("-");
const windKph = ref("-");
const windDir = ref("-");
const pressureMb = ref("-");
const precipMm = ref("-");
const humidity = ref("-");
const maxTempC = ref("-");
const minTempC = ref("-");
const avgTempC = ref("-");
const avgHumidity = ref("-");
const showData = ref(false);

function showDataWeather() {
  showData.value = !showData.value;
}

const newData = computed(() => {
  return [devicesStore.deviceData];
});

const title = ref();
const device_code = ref();
let satStatParams = {
  fields: "S15",
  measurement: "SATSTAT",
  device_code: null,
};

onBeforeMount(async () => {
  loadingData.value = true;
  await devicesStore.loadDevice(props.id);
  const data = await weatherStore.getCurrent(
    devicesStore.deviceData.coordinate
  );

  if (data.current !== undefined) {
    tempC.value = data.current.temp_c;
    windKph.value = data.current.wind_kph;
    windDir.value = data.current.wind_dir;
    pressureMb.value = data.current.pressure_mb;
    precipMm.value = data.current.precip_mm;
    humidity.value = data.current.humidity;

    if (data.forecast.forecastday.length !== 0) {
      const forecastDay = data.forecast.forecastday[0].day;
      maxTempC.value = forecastDay.maxtemp_c;
      minTempC.value = forecastDay.mintemp_c;
      avgTempC.value = forecastDay.avgtemp_c;
      avgHumidity.value = forecastDay.avghumidity;
    }
  }

  satStatParams.device_code = devicesStore.deviceData.code;
  title.value = "Idrosat:" + devicesStore.deviceData.name;
  device_code.value = devicesStore.deviceData.code;

  loadingData.value = false;
});

const isShowAlarmModal = ref(false);

async function deviceAlarmToggle() {
  await alarmStore.getAlarmList(device_code.value);
  isShowAlarmModal.value = !isShowAlarmModal.value;
}
</script>

<style scoped>
.dashboard-container {
  @apply flex flex-col w-full justify-center items-center;
}

.device-container {
  @apply flex sm:flex-col fixed items-end sm:items-center gap-2
    bottom-0 left-4
    pb-4 sm:pb-8;
}

.content {
  @apply flex flex-wrap justify-center 
    w-[300px] gap-1
    sm:w-[500px] sm:gap-6
    md:w-[700px] md:gap-8
    lg:w-[800px] lg:gap-10
    transition-all ease-in-out delay-300;
}

/* .content img {
  @apply 
  w-24 h-24
  sm:w-32 sm:h-32 
  md:w-40 md:h-40 
  lg:w-60 lg:h-60
  transition-all ease-in-out delay-150
} */
</style>
